/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { TransmittalDocumentFileInfoDto } from './transmittalDocumentFileInfoDto.schema';

export const IEnumerableOfTransmittalDocumentFileInfoDto = zod.array(zod.lazy(() => TransmittalDocumentFileInfoDto));

export type IEnumerableOfTransmittalDocumentFileInfoDto = zod.input<typeof IEnumerableOfTransmittalDocumentFileInfoDto>;
export type IEnumerableOfTransmittalDocumentFileInfoDtoOutput = zod.output<typeof IEnumerableOfTransmittalDocumentFileInfoDto>;
